/**
 * URL pública do produto na loja (para copiar e enviar ao cliente).
 * Em localhost ainda gera o link de produção, para o cliente conseguir abrir.
 */

import { getStorefrontOrigin } from './appOrigins';

export { getStorefrontOrigin };

export function getStorefrontProductUrl(productId) {
  const id = Number(productId);
  if (!Number.isFinite(id) || id === 0) {
    throw new Error('Produto inválido para gerar link');
  }
  return `${getStorefrontOrigin()}/products/${id}`;
}

export async function copyStorefrontProductUrl(productId) {
  const url = getStorefrontProductUrl(productId);
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
  } else {
    const textarea = document.createElement('textarea');
    textarea.value = url;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.left = '-9999px';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }
  return url;
}
